(function () {
  'use strict';

  const section = document.querySelector('.jc-section[data-section-id]');
  // Storefront-language strings rendered by Liquid (see data-i18n-* on the section).
  const i18n = {
    title: section?.dataset.i18nTitle || 'Originálny dres __TITLE__',
    loading: section?.dataset.i18nLoading || 'Načítavam...',
    loadError: section?.dataset.i18nLoadError || 'Chyba načítania.',
    genderMen: section?.dataset.i18nGenderMen || 'Pánsky',
    genderWomen: section?.dataset.i18nGenderWomen || 'Dámsky',
  };
  if (!section) return;

  const jerseyImg = document.getElementById('jc-jersey-img');
  const canvas = document.getElementById('jc-canvas');
  const ctx = canvas.getContext('2d');

  const cfg = {
    textColor: section.dataset.textColor || '#D7B77C',
    textFont: section.dataset.textFont || 'TT Carvist',
    textStroke: section.dataset.textStroke || '#003399',
    nameY: parseFloat(section.dataset.nameY) || 44,
    numberY: parseFloat(section.dataset.numberY) || 50,
    logoWidth: parseFloat(section.dataset.logoWidth) || 26,
  };

  const UPPERCASE_ONLY_FONTS = ['Dresy 2526'];

  let state = {
    variantId: null,
    price: null,
    persType: 'player',
    name: '',
    number: '',
    logo: '',
    logoImg: '',
    visa: false,
    activeGender: null,
    activeHandle: null,
    activeImg: null,
    // The preview shows the front of the jersey until the customer starts the personalisation;
    // a player page starts with that player's name on the back.
    side: section?.dataset.lockPlayer === 'true' ? 'back' : 'front',
    imgBack: '',
    imgFront: '',
  };

  let blocks = [];
  const productCache = new Map();
  try {
    const el = document.getElementById('jc-blocks-data');
    blocks = el ? JSON.parse(el.textContent) : [];
  } catch { blocks = []; }

  /* ── Addon products (Personalizácia / Logo) ── */

  const addons = {
    pers: { handle: document.getElementById('jc-pers-tabs')?.dataset.addonHandle || '', variantId: null, price: null },
    logo: { handle: document.getElementById('jc-logo-tabs')?.dataset.addonHandle || '', variantId: null, price: null },
  };

  async function loadAddon(key) {
    const addon = addons[key];
    if (!addon.handle) return;
    try {
      const res = await fetch(`/products/${addon.handle}.js`);
      if (!res.ok) throw new Error();
      const product = await res.json();
      const variant = product.variants.find(v => v.available) || product.variants[0];
      if (!variant) return;
      addon.variantId = variant.id;
      addon.price = variant.price;
      applyAddonPriceToLabels(key, variant.price);
      updatePrice();
    } catch {
      /* addon stays unpriced — treated as not configured */
    }
  }

  function applyAddonPriceToLabels(key, price) {
    const priceText = `+${(price / 100).toFixed(2).replace('.', ',')} €`;
    const selector = key === 'pers'
      ? '#jc-pers-tabs .sl-pill[data-pers]:not(.sl-pill--none)'
      : '#jc-logo-tabs .sl-pill[data-logo]:not(.sl-pill--none)';
    document.querySelectorAll(selector).forEach(btn => {
      if (!btn.dataset.baseLabel) btn.dataset.baseLabel = btn.textContent.trim();
      const label = document.createElement('span');
      label.className = 'sl-pill__label';
      label.textContent = btn.dataset.baseLabel;
      const priceEl = document.createElement('span');
      priceEl.className = 'sl-pill__price';
      priceEl.textContent = priceText;
      btn.replaceChildren(label, priceEl);
    });
  }

  /* ── Canvas ── */

  let cw = 0, ch = 0;

  function syncPreviewBox() {
    const wrap = jerseyImg.parentElement;
    if (!wrap || !jerseyImg.naturalWidth || !jerseyImg.naturalHeight) return;
    const w = wrap.offsetWidth;
    if (w) wrap.style.minHeight = `${w * (jerseyImg.naturalHeight / jerseyImg.naturalWidth)}px`;
  }

  function syncCanvas() {
    const dpr = window.devicePixelRatio || 1;
    cw = jerseyImg.offsetWidth;
    ch = jerseyImg.offsetHeight;
    canvas.width = Math.round(cw * dpr);
    canvas.height = Math.round(ch * dpr);
    canvas.style.width = cw + 'px';
    canvas.style.height = ch + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  // The patch is not drawn on the jersey — it sits beside the sleeve with a caption.
  const patchBox = document.getElementById('jc-patch');
  const patchImg = document.getElementById('jc-patch-img');

  function renderPatch() {
    if (!patchBox || !patchImg) return;
    if (state.logoImg) {
      if (patchImg.getAttribute('src') !== state.logoImg) patchImg.src = state.logoImg;
      patchImg.alt = state.logo || '';
      patchBox.style.width = cfg.logoWidth + '%';
      patchBox.hidden = false;
    } else {
      patchBox.hidden = true;
    }
  }

  function drawCanvas() {
    syncCanvas();
    ctx.clearRect(0, 0, cw, ch);
    renderPatch();

    // Name and number go on the back only.
    if (state.side === 'front' && state.imgFront) return;

    // The 2025/26 jersey font only has capitals (as on the real shirts), so names are capitalised
    // there; fonts with lower case keep "Šporar" as written.
    const name = UPPERCASE_ONLY_FONTS.includes(cfg.textFont) ? (state.name || '').toUpperCase() : state.name || '';
    const number = String(state.number || '');
    if (!name && !number && !state.visa) return;

    const nameY = (cfg.nameY / 100) * ch;
    const numberY = (cfg.numberY / 100) * ch;
    const cx = cw / 2;

    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    if (number) {
      // Width cap besides the height cap: the light blue and grey jerseys use a wide font,
      // so a size that fits the condensed font ran over the sleeves there (mainly on mobile).
      const maxNumberWidth = cw * 0.36;
      let fs = Math.min(204, cw * 0.48);
      ctx.font = `600 ${fs}px '${cfg.textFont}', sans-serif`;
      const measuredNumber = ctx.measureText(number).width;
      if (measuredNumber > maxNumberWidth) {
        fs = fs * (maxNumberWidth / measuredNumber);
        ctx.font = `600 ${fs}px '${cfg.textFont}', sans-serif`;
      }
      ctx.fillStyle = cfg.textColor;
      ctx.globalAlpha = 1;
      ctx.fillText(number, cx, numberY);
    }

    drawVisa(cx, numberY);

    if (name) {
      const maxNameWidth = cw * 0.44;
      const minFs = Math.min(32, cw * 0.068);
      let fs = Math.min(60, cw * 0.12);
      ctx.font = `600 ${fs}px '${cfg.textFont}', sans-serif`;
      const measured = ctx.measureText(name).width;
      if (measured > maxNameWidth) {
        fs = Math.max(minFs, fs * (maxNameWidth / measured));
        ctx.font = `600 ${fs}px '${cfg.textFont}', sans-serif`;
      }
      ctx.fillStyle = cfg.textColor;
      ctx.globalAlpha = 1;
      ctx.fillText(name, cx, nameY);
    }

    ctx.restore();
  }

  /* ── VISA sponsor logo ── */

  const visaImgs = {};
  function visaImage(kind) {
    const url = kind === 'gold' ? section.dataset.visaGold : section.dataset.visaBlack;
    if (!url) return null;
    if (!visaImgs[kind]) {
      visaImgs[kind] = new Image();
      visaImgs[kind].onload = drawCanvas;
      visaImgs[kind].src = url;
    }
    return visaImgs[kind].complete && visaImgs[kind].naturalWidth ? visaImgs[kind] : null;
  }

  /** Gold logo for a light (gold) print, black for a dark one — matches the print colour. */
  function visaKind() {
    const hex = (cfg.textColor || '').replace('#', '');
    if (hex.length < 6) return 'black';
    const [r, g, b] = [0, 2, 4].map(i => parseInt(hex.slice(i, i + 2), 16));
    return 0.299 * r + 0.587 * g + 0.114 * b > 128 ? 'gold' : 'black';
  }

  /**
   * VISA under the number, only with the Nike liga patch. Sized from the club's PDF: the gap
   * under the digits is ~22 % and the logo width ~60 % of the digit height. Measured on "0"
   * so the logo does not move when the number changes or is still empty.
   */
  function drawVisa(cx, numberY) {
    if (!state.visa) return;
    const img = visaImage(visaKind());
    if (!img) return;
    ctx.save();
    ctx.textBaseline = 'middle';
    let fs = Math.min(204, cw * 0.48);
    ctx.font = `600 ${fs}px '${cfg.textFont}', sans-serif`;
    const sample = state.number || '0';
    const sampleWidth = ctx.measureText(sample).width;
    if (sampleWidth > cw * 0.36) fs = fs * ((cw * 0.36) / sampleWidth);
    ctx.font = `600 ${fs}px '${cfg.textFont}', sans-serif`;
    const m = ctx.measureText('0');
    const digitHeight = m.actualBoundingBoxAscent + m.actualBoundingBoxDescent;
    const digitBottom = numberY + m.actualBoundingBoxDescent;
    const w = digitHeight * 0.6;
    const h = w * (img.naturalHeight / img.naturalWidth);
    ctx.drawImage(img, cx - w / 2, digitBottom + digitHeight * 0.22, w, h);
    ctx.restore();
  }

  /* ── Custom select ── */

  function buildCustomSelect() {
    const select = document.getElementById('jc-player-select');
    if (!select) return;

    select.style.display = 'none';
    const wrap = select.parentElement;

    const custom = document.createElement('div');
    custom.className = 'jc-custom-select';
    custom.id = 'jc-player-custom-select';
    custom.innerHTML = `
      <div class="jc-custom-select__trigger">
        <span class="jc-custom-select__value"></span>
        <svg class="jc-custom-select__arrow" width="12" height="8" viewBox="0 0 12 8" fill="none"><path d="M1 1l5 5 5-5" stroke="#7E97A4" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
      </div>
      <div class="jc-custom-select__dropdown"></div>
    `;

    const dropdown = custom.querySelector('.jc-custom-select__dropdown');
    const valueEl = custom.querySelector('.jc-custom-select__value');

    function buildOptions() {
      dropdown.innerHTML = '';
      Array.from(select.options).forEach((opt, i) => {
        const item = document.createElement('div');
        item.className = 'jc-custom-select__option' + (i === select.selectedIndex ? ' is-selected' : '');
        item.dataset.value = opt.value;
        item.dataset.number = opt.dataset.number || '';
        item.textContent = opt.textContent.trim();
        item.addEventListener('click', () => {
          select.value = opt.value;
          valueEl.textContent = opt.textContent.trim();
          valueEl.classList.toggle('jc-custom-select__value--placeholder', !opt.value);
          dropdown.querySelectorAll('.jc-custom-select__option').forEach(o => o.classList.remove('is-selected'));
          item.classList.add('is-selected');
          custom.classList.remove('is-open');
          select.dispatchEvent(new Event('change'));
        });
        dropdown.appendChild(item);
      });
      const current = select.options[select.selectedIndex];
      valueEl.textContent = current ? current.textContent.trim() : '';
      valueEl.classList.toggle('jc-custom-select__value--placeholder', !select.value);
    }

    buildOptions();

    custom.querySelector('.jc-custom-select__trigger').addEventListener('click', () => {
      custom.classList.toggle('is-open');
    });

    document.addEventListener('click', e => {
      if (!custom.contains(e.target)) custom.classList.remove('is-open');
    });

    wrap.appendChild(custom);

    const origRenderSizes = renderSizes;
    select._rebuildCustom = buildOptions;
  }

  /* ── Variants ── */

  async function loadVariants(handle) {
    const el = document.getElementById('jc-sizes');

    if (productCache.has(handle)) {
      renderSizes(productCache.get(handle).variants);
      return;
    }

    // Keep the height of the size buttons while loading, a one-line "loading" text made the
    // whole section (and its cover background) jump.
    el.style.minHeight = `${el.offsetHeight}px`;
    el.innerHTML = `<span class="jc-loading">${i18n.loading}</span>`;
    state.variantId = null;
    state.price = null;
    updatePrice();
    updateCartBtn();

    try {
      const res = await fetch(`/products/${handle}.js`);
      if (!res.ok) throw new Error();
      const product = await res.json();
      productCache.set(handle, product);
      renderSizes(product.variants);
    } catch {
      el.innerHTML = `<span class="jc-loading">${i18n.loadError}</span>`;
      el.style.minHeight = '';
    }
  }

  /** Loads the sizes of the other jerseys in the background, so switching is instant. */
  function prefetchVariants() {
    const handles = new Set(
      Array.from(document.querySelectorAll('#jc-thumbs .jc-thumb'))
        .map(t => t.dataset.handle)
        .filter(h => h && !productCache.has(h))
    );
    handles.forEach(handle => {
      fetch(`/products/${handle}.js`)
        .then(res => (res.ok ? res.json() : null))
        .then(product => { if (product && !productCache.has(handle)) productCache.set(handle, product); })
        .catch(() => {});
    });
  }

  function renderSizes(variants) {
    const select = document.getElementById('jc-player-select');
    if (select?._rebuildCustom) select._rebuildCustom();
    const el = document.getElementById('jc-sizes');
    const prevVariantId = state.variantId;
    el.innerHTML = '';
    el.style.minHeight = '';
    const rows = Math.ceil(variants.length / 6) || 1;
    el.style.setProperty('--jc-size-cols', Math.ceil(variants.length / rows) || 1);
    variants.forEach(v => {
      const btn = document.createElement('button');
      btn.className = 'sl-pill';
      btn.type = 'button';
      btn.textContent = v.title;
      btn.dataset.variantId = v.id;
      btn.dataset.price = v.price;
      btn.disabled = !v.available;
      btn.addEventListener('click', () => selectSize(btn, v));
      el.appendChild(btn);
    });

    if (prevVariantId) {
      const prevVariant = variants.find(v => v.id === prevVariantId && v.available);
      const prevBtn = el.querySelector(`[data-variant-id="${prevVariantId}"]`);
      if (prevVariant && prevBtn) {
        selectSize(prevBtn, prevVariant);
      }
    }
  }

  function selectSize(btn, variant) {
    document.querySelectorAll('#jc-sizes .sl-pill').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    state.variantId = variant.id;
    state.price = variant.price;
    updatePrice();
    updateCartBtn();
  }

  function updateTitle(title) {
    const el = document.getElementById('jc-product-title');
    if (el && title) el.textContent = i18n.title.replace('__TITLE__', title);
  }

  const formatPrice = cents => (cents / 100).toFixed(2).replace('.', ',') + ' €';
  let shownPrice = null;
  let priceFrame = null;

  function updatePrice() {
    const el = document.getElementById('jc-price');
    if (!state.price) {
      if (priceFrame) cancelAnimationFrame(priceFrame);
      shownPrice = null;
      el.textContent = '—';
      return;
    }
    let total = state.price;
    if (state.persType !== 'none' && addons.pers.price) total += addons.pers.price;
    if (state.logo && addons.logo.price) total += addons.logo.price;
    animatePrice(el, total);
  }

  /** Counts the price up or down to the new total and gives it a short pulse. */
  function animatePrice(el, total) {
    if (priceFrame) cancelAnimationFrame(priceFrame);
    const from = shownPrice;
    shownPrice = total;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (from === null || from === total || reduce) {
      el.textContent = formatPrice(total);
      return;
    }
    el.classList.remove('is-up', 'is-down');
    void el.offsetWidth;
    el.classList.add(total > from ? 'is-up' : 'is-down');
    const start = performance.now();
    const duration = 450;
    const step = now => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatPrice(Math.round(from + (total - from) * eased));
      priceFrame = t < 1 ? requestAnimationFrame(step) : null;
    };
    priceFrame = requestAnimationFrame(step);
  }

  function isPersValid() {
    if (state.persType === 'none') return true;
    if (state.persType === 'player') {
      const sel = document.getElementById('jc-player-select');
      return !sel || Boolean(sel.value);
    }
    return Boolean(state.name.trim() && state.number);
  }

  function updateCartBtn() {
    document.getElementById('jc-add-to-cart').disabled = !state.variantId || !isPersValid();
  }

  /* ── Gender tabs (dynamic) ── */

  function initGenderTabs() {
    const group = document.getElementById('jc-gender-group');
    const tabs = document.getElementById('jc-gender-tabs');
    if (!group || !tabs) return;

    const showGender = section.dataset.showGender === 'true';
    const genders = [...new Set(blocks.map(b => b.gender).filter(Boolean))];

    if (!showGender || genders.length < 2) {
      filterThumbs('pansky');
      return;
    }

    const labels = { pansky: i18n.genderMen, damsky: i18n.genderWomen };

    const genderOrder = ['pansky', 'damsky'];
    const sortedGenders = genderOrder.filter(g => genders.includes(g));
    const extraGenders = genders.filter(g => !genderOrder.includes(g));
    const orderedGenders = [...sortedGenders, ...extraGenders];

    orderedGenders.forEach((g, i) => {
      const btn = document.createElement('button');
      btn.className = 'sl-pill' + (i === 0 ? ' is-active' : '');
      btn.type = 'button';
      btn.dataset.gender = g;
      btn.textContent = labels[g] || g;
      btn.addEventListener('click', () => selectGender(g));
      tabs.appendChild(btn);
    });

    group.style.display = '';
    state.activeGender = orderedGenders[0];
    filterThumbs(orderedGenders[0]);
  }

  function selectGender(gender) {
    state.activeGender = gender;
    document.querySelectorAll('#jc-gender-tabs .sl-pill').forEach(b => {
      b.classList.toggle('is-active', b.dataset.gender === gender);
    });
    filterThumbs(gender);
  }

  function filterThumbs(gender) {
    const thumbs = document.querySelectorAll('#jc-thumbs .jc-thumb');
    let firstVisible = null;
    thumbs.forEach(t => {
      const show = t.dataset.gender === gender;
      t.style.display = show ? '' : 'none';
      if (show && !firstVisible) firstVisible = t;
    });
    if (firstVisible) activateThumb(firstVisible);
  }

  /* ── Thumbnails ── */

  // Pre-order jerseys swap the info box for the shipping promise; the others keep the
  // personalisation notice from the section settings.
  function updateInfoBox(isPreorder) {
    const box = document.getElementById('jc-info-box');
    if (!box) return;
    // Both texts stay in the box and only switch visibility, so its height never changes.
    const texts = box.querySelectorAll('.jc-info-box__text');
    const hasText = kind => Array.from(texts).some(t => t.dataset.info === kind && t.textContent.trim());
    const active = isPreorder && hasText('preorder') ? 'preorder' : 'default';
    texts.forEach(t => t.setAttribute('aria-hidden', String(t.dataset.info !== active)));
    box.hidden = !hasText('default') && !hasText('preorder');
    box.classList.toggle('jc-info-box--preorder', active === 'preorder');
  }

  function activateThumb(thumb) {
    document.querySelectorAll('#jc-thumbs .jc-thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');

    const handle = thumb.dataset.handle;
    const img = thumb.dataset.img;
    const title = thumb.dataset.title;

    if (title) updateTitle(title);
    updateInfoBox(thumb.dataset.preorder === 'true');

    if (thumb.dataset.textColor) cfg.textColor = thumb.dataset.textColor;
    if (thumb.dataset.font && thumb.dataset.font !== cfg.textFont) {
      cfg.textFont = thumb.dataset.font;
      if (document.fonts) {
        document.fonts.load(`600 48px '${cfg.textFont}'`).then(drawCanvas).catch(drawCanvas);
      }
    }

    if (handle && handle !== state.activeHandle) {
      state.activeHandle = handle;
      loadVariants(handle);
    }

    state.imgBack = img || '';
    state.imgFront = thumb.dataset.imgFront || '';
    showJersey(false);
  }

  /* ── Front / back ── */

  const reduceMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

  /** Shows the current side of the current jersey; `turn` animates it like a turned shirt. */
  function showJersey(turn) {
    const url = state.side === 'back' || !state.imgFront ? state.imgBack : state.imgFront;
    if (!url || url === state.activeImg) {
      drawCanvas();
      return;
    }
    state.activeImg = url;
    const preloader = new Image();
    preloader.onload = () => {
      if (state.activeImg !== url) return;
      const swap = () => {
        jerseyImg.src = url;
        syncPreviewBox();
        drawCanvas();
      };
      if (!turn || reduceMotion || !jerseyImg.animate) return swap();
      const layers = [jerseyImg, canvas];
      const squeeze = [{ transform: 'scaleX(1)' }, { transform: 'scaleX(0.02)' }];
      const closing = layers.map(el => el.animate(squeeze, { duration: 200, easing: 'ease-in', fill: 'forwards' }));
      closing[0].finished.then(() => {
        swap();
        layers.forEach((el, i) => {
          el.animate([...squeeze].reverse(), { duration: 200, easing: 'ease-out' });
          closing[i].cancel();
        });
      }).catch(() => {});
    };
    preloader.src = url;
  }

  function turnToBack() {
    if (state.side === 'back') return;
    state.side = 'back';
    showJersey(true);
  }

  function turnToFront() {
    if (state.side === 'front') return;
    state.side = 'front';
    showJersey(true);
  }

  function syncSide() {
    if (state.persType !== 'none' || state.visa) turnToBack();
    else turnToFront();
  }

  /* ── Personalization ── */

  function updatePreview() {
    if (state.persType === 'none') {
      state.name = '';
      state.number = '';
    } else if (state.persType === 'player') {
      const sel = document.getElementById('jc-player-select');
      const opt = sel?.options[sel.selectedIndex];
      // Written as on the real shirt: capital first letter, the rest lower case ("Šporar").
      state.name = opt?.dataset.surname || '';
      state.number = opt?.dataset.number || '';
    } else {
      const typed = (document.getElementById('jc-custom-name')?.value || '').trim();
      state.name = typed.charAt(0).toUpperCase() + typed.slice(1);
      const numEl = document.getElementById('jc-custom-number');
      const rawNum = parseInt(numEl?.value);
      if (!isNaN(rawNum)) {
        const clamped = Math.min(99, Math.max(1, rawNum));
        if (numEl && clamped !== rawNum) numEl.value = clamped;
        state.number = String(clamped);
      } else {
        state.number = '';
      }
    }
    updateCartBtn();
    drawCanvas();
  }

  function switchPers(type) {
    state.persType = type;
    document.querySelectorAll('#jc-pers-tabs .sl-pill').forEach(b => {
      b.classList.toggle('is-active', b.dataset.pers === type);
    });
    document.getElementById('jc-pane-player').classList.toggle('is-active', type === 'player');
    document.getElementById('jc-pane-custom').classList.toggle('is-active', type === 'custom');
    updatePreview();
    updatePrice();
  }

  /* ── Cart ── */

  async function addToCart() {
    if (!state.variantId || !isPersValid()) return;
    const btn = document.getElementById('jc-add-to-cart');
    const errEl = document.getElementById('jc-error');
    const origText = btn.textContent;
    errEl.hidden = true;
    btn.disabled = true;
    btn.classList.add('is-loading');
    btn.textContent = '...';

    const dresTitle = document.getElementById('jc-product-title')?.textContent || '';

    const persProperties = {
      ...(state.name ? { 'Meno': state.name } : {}),
      ...(state.number ? { 'Číslo': state.number } : {}),
    };

    const addonSummary = [];
    const withPers = state.persType !== 'none' && addons.pers.variantId;
    if (withPers) addonSummary.push(`Personalizácia (${state.persType === 'player' ? 'Hráč' : 'Vlastné'})`);
    if (state.logo && addons.logo.variantId) addonSummary.push(`Logo na dres (${state.logo})`);

    const items = [{
      id: state.variantId,
      quantity: 1,
      properties: {
        ...persProperties,
        ...(addonSummary.length ? { 'Doplnky': addonSummary.join(', ') } : {}),
      }
    }];

    if (withPers) {
      items.push({
        id: addons.pers.variantId,
        quantity: 1,
        properties: {
          'Dres': dresTitle,
          ...persProperties,
        }
      });
    }

    if (state.logo && addons.logo.variantId) {
      items.push({
        id: addons.logo.variantId,
        quantity: 1,
        properties: { 'Dres': dresTitle, 'Logo': state.logo }
      });
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) {
        const d = await res.json();
        throw new Error(d.description || 'Chyba');
      }
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      btn.textContent = origText;
      btn.disabled = false;
      btn.classList.remove('is-loading');
      showSuccess();
    } catch (err) {
      errEl.textContent = err.message;
      errEl.hidden = false;
      btn.textContent = origText;
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }
  }

  /* ── Success / Reset ── */

  function showSuccess() {
    document.getElementById('jc-form-content').hidden = true;
    document.getElementById('jc-success-panel').hidden = false;
  }

  function resetForm() {
    document.getElementById('jc-success-panel').hidden = true;
    document.getElementById('jc-form-content').hidden = false;

    state.variantId = null;
    state.price = null;
    state.name = '';
    state.number = '';
    state.logo = '';
    state.logoImg = '';
    state.visa = false;

    const nameEl = document.getElementById('jc-custom-name');
    const numEl = document.getElementById('jc-custom-number');
    if (nameEl) nameEl.value = '';
    if (numEl) numEl.value = '';

    const playerSelect = document.getElementById('jc-player-select');
    if (playerSelect) {
      const preset = Array.from(playerSelect.options).findIndex(o => o.defaultSelected);
      playerSelect.selectedIndex = section?.dataset.lockPlayer === 'true' && preset > 0 ? preset : 0;
      playerSelect.dispatchEvent(new Event('change'));
    }

    document.querySelectorAll('#jc-logo-tabs .sl-pill').forEach((b, i) => {
      b.classList.toggle('is-active', i === 0);
    });

    const lockPlayer = section?.dataset.lockPlayer === 'true';
    switchPers(lockPlayer ? 'player' : 'none');
    updatePrice();
    updateCartBtn();
    state.side = lockPlayer ? 'back' : 'front';
    showJersey(true);
  }

  /* ── Init ── */

  function init() {
    buildCustomSelect();
    initGenderTabs();
    loadAddon('pers');
    loadAddon('logo');

    // On a product page start on that page's jersey; elsewhere on the first thumbnail.
    const pageHandle = section.dataset.activeHandle;
    const pageThumb = pageHandle
      ? document.querySelector(`#jc-thumbs .jc-thumb[data-handle="${pageHandle}"]:not([data-demo])`)
      : null;
    const firstThumb = pageThumb || document.querySelector('#jc-thumbs .jc-thumb');
    if (firstThumb) activateThumb(firstThumb);
    else if (blocks.length > 0) loadVariants(blocks[0].handle);

    document.getElementById('jc-thumbs')?.addEventListener('click', e => {
      const thumb = e.target.closest('.jc-thumb');
      if (!thumb) return;
      activateThumb(thumb);
      thumb.blur();
    });

    const activePers = document.querySelector('#jc-pers-tabs .sl-pill.is-active[data-pers]');
    if (activePers) state.persType = activePers.dataset.pers;

    document.getElementById('jc-pers-tabs')?.addEventListener('click', e => {
      const pill = e.target.closest('.sl-pill[data-pers]');
      if (pill) switchPers(pill.dataset.pers);
    });

    // Any real interaction with the personalisation (tab, player list, typing) turns the jersey
    // to its back. isTrusted skips the programmatic change events, e.g. the preselected player
    // on a player page, so that page also opens on the front.
    const persGroup = document.querySelector('.jc-form-group--pers');
    ['click', 'input', 'keydown'].forEach(type => {
      persGroup?.addEventListener(type, e => {
        if (!e.isTrusted) return;
        if (e.target.closest('.sl-pill--none')) syncSide();
        else turnToBack();
      });
    });

    document.getElementById('jc-player-select')?.addEventListener('change', updatePreview);
    document.getElementById('jc-custom-name')?.addEventListener('input', updatePreview);
    document.getElementById('jc-custom-number')?.addEventListener('input', updatePreview);
    document.getElementById('jc-add-to-cart')?.addEventListener('click', addToCart);
    document.getElementById('jc-restart')?.addEventListener('click', resetForm);
    document.getElementById('jc-scroll-preview')?.addEventListener('click', () => {
      document.querySelector('.jc-canvas-wrap')?.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    });

    const logoTabs = document.getElementById('jc-logo-tabs');
    if (logoTabs) {
      const firstLogo = logoTabs.querySelector('.sl-pill[data-logo]');
      if (firstLogo) state.logo = firstLogo.dataset.logo;
      logoTabs.addEventListener('click', e => {
        const pill = e.target.closest('.sl-pill[data-logo]');
        if (!pill) return;
        logoTabs.querySelectorAll('.sl-pill').forEach(b => b.classList.remove('is-active'));
        pill.classList.add('is-active');
        state.logo = pill.dataset.logo;
        state.logoImg = pill.dataset.logoImg || '';
        state.visa = pill.dataset.visa === 'true';
        // Each logo goes on a different shoulder, so the caption comes with the logo.
        const patchNote = document.getElementById('jc-patch-note');
        if (patchNote && pill.dataset.patchNote) patchNote.textContent = pill.dataset.patchNote;
        syncSide();
        drawCanvas();
        updatePrice();
      });
    }

    jerseyImg.addEventListener('load', () => { syncPreviewBox(); syncCanvas(); drawCanvas(); });
    if (jerseyImg.complete) { syncPreviewBox(); syncCanvas(); drawCanvas(); }
    window.addEventListener('resize', () => { syncPreviewBox(); syncCanvas(); drawCanvas(); });

    updatePreview();
    prefetchVariants();
    // Load both VISA logos up front, so picking Nike liga shows the logo at once.
    visaImage('gold');
    visaImage('black');
  }

  if (document.fonts) {
    document.fonts.load(`600 48px '${cfg.textFont}'`).then(init).catch(init);
  } else {
    init();
  }
})();
